/* @ngInject */
const railwayButtons = (
  railwayAsk,
  railwayGo,
  icons
) => {
  const self = {}

  self.search = {
    icon: icons.search,
    action: railwayGo.consult,
    display: _nature => _nature === 'tables',
  }

  self.edit = {
    icon: icons.edit,
    action: railwayGo.edit,
    display: () => true,
  }

  self.delete = {
    icon: icons.delete,
    action: railwayAsk.delete,
    display: _nature => _nature === 'action',
    class: _railway => 'retour',
  }

  return self
}
export default railwayButtons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/resources/buttons.resource.js